import { getContrast, mix, toHex } from 'color2k';

const rgbTuple = hex => {
  const hexDigits = hex.replace('#', '');
  return [0, 2, 4].map(offset =>
    Number.parseInt(hexDigits.slice(offset, offset + 2), 16)
  );
};

const mixedRGB = (rgb, target, weight) =>
  rgb
    .map((channel, index) =>
      Math.round(channel * (1 - weight) + target[index] * weight)
    )
    .join(' ');

const readableBrandRGB = (primaryColor, backgroundColor, target) => {
  for (let step = 2; step < 10; step += 1) {
    const shade = toHex(mix(primaryColor, target, step / 10));
    if (getContrast(shade, backgroundColor) >= 4.5) {
      return rgbTuple(shade);
    }
  }
  return rgbTuple(target);
};

const SURFACE_SCALES = {
  light: {
    target: [255, 255, 255],
    weights: [0.98, 0.96, 0.92, 0.86, 0.8, 0.76, 0.72],
  },
  dark: {
    target: [17, 17, 19],
    weights: [0.94, 0.92, 0.88, 0.84, 0.78, 0.72, 0.65],
  },
};

const surfaceProperties = rgb =>
  Object.entries(SURFACE_SCALES).flatMap(([theme, scale]) =>
    scale.weights.map((weight, index) => [
      `--taco-brand-${theme}-${index + 1}`,
      mixedRGB(rgb, scale.target, weight),
    ])
  );

const textProperties = primaryColor => {
  // Reference the light slate-5 and dark solid-active neutral surfaces.
  const lightText = readableBrandRGB(primaryColor, '#e0e1e6', '#000000');
  const darkText = readableBrandRGB(primaryColor, '#353942', '#ffffff');
  return [
    ['--taco-brand-text-light', lightText.join(' ')],
    ['--taco-brand-text-dark', darkText.join(' ')],
    ['--taco-brand-light-12', mixedRGB(lightText, [0, 0, 0], 0.2)],
    ['--taco-brand-dark-12', mixedRGB(darkText, [255, 255, 255], 0.4)],
  ];
};

export const applyAccountColor = primaryColor => {
  const rgb = rgbTuple(primaryColor);
  const tones = [...surfaceProperties(rgb), ...textProperties(primaryColor)];
  const themeScopes = [document.documentElement, document.body].filter(Boolean);
  themeScopes.forEach(scope => {
    scope.style.setProperty('--taco-account-brand', primaryColor);
    scope.style.setProperty('--blue-8', mixedRGB(rgb, [255, 255, 255], 0.16));
    scope.style.setProperty('--blue-9', rgb.join(' '));
    scope.style.setProperty('--blue-10', mixedRGB(rgb, [0, 0, 0], 0.1));
    scope.style.removeProperty('--blue-11');
    tones.forEach(([property, tuple]) =>
      scope.style.setProperty(property, tuple)
    );
  });
};
